import { useEffect, useState } from 'react';

import { downloadFilesApi } from '@/integrations/index.api';
import { handleError } from '@/services/handleError';

import { imageStore } from './helpers';

export function useImageSrc(
  src: string | undefined,
  loadingFromParent: boolean
) {
  const [state, setState] = useState(() =>
    src ? imageStore.getState(src) : { loading: false, error: false, src: null }
  );

  useEffect(() => {
    if (!src) return;

    // Синхронно берём актуальное состояние (могло уже загрузиться)
    setState(imageStore.getState(src));

    // Подписываемся на изменения
    const unsubscribe = imageStore.subscribe(src, setState);

    // Запускаем загрузку (не дублируется, если уже идёт)
    imageStore
      .loadImage(
        src,
        (url, signal) => downloadFilesApi.imageToWebp(url, signal),
        loadingFromParent
      )
      .catch((error) => handleError(error, { notify: false }));

    return unsubscribe;
  }, [src, loadingFromParent]);

  return state;
}
